'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGlobals$0024 from "./presto.-Globals$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SingleAppToken(created, expires, user) {
  this.Z3 = null;
  this.Z4 = null;
  this.fC = null;
  this.Z3 = created;
  this.Z4 = expires;
  this.fC = user;
}
export { $c_Lpresto_types$SingleAppToken as $c_Lpresto_types$SingleAppToken };
$p = $c_Lpresto_types$SingleAppToken.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SingleAppToken;
/** @constructor */
function $h_Lpresto_types$SingleAppToken() {
}
export { $h_Lpresto_types$SingleAppToken as $h_Lpresto_types$SingleAppToken };
$h_Lpresto_types$SingleAppToken.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$SingleAppToken)) {
    var x = this.Z3;
    var x$2 = x$0.Z3;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.Z4;
      var x$4 = x$0.Z4;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.fC;
      var x$6 = x$0.fC;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "SingleAppToken";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Z3;
      break;
    }
    case 1: {
      return this.Z4;
      break;
    }
    case 2: {
      return this.fC;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.cKp = (function(code) {
  return this.fC.ud.xp.cL(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$9) => _$9.DZ))).aG(code);
});
$p.cPw = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_IterableOnceOps__mkString__T__T__T__T(this.fC.ud.xp.cL(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$10) => _$10.DZ))).a2(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((t) => t))), "", ", ", "");
});
$p.aex = (function() {
  var this$1 = this.fC.hi.jj;
  var b = $j_presto$002e$002dGlobals$0024.$m_Lpresto_Globals$().n1;
  return ((this$1.e === b.e) && (this$1.f === b.f));
});
$p.cFF = (function() {
  return this.fC.ud.xq.cL(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$11) => _$11.Le)));
});
$p.aen = (function(code) {
  return this.fC.ud.xq.hw(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$13) => (_$13.Ld === code))));
});
$p.zA = (function(code) {
  return this.cFF().hw(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$14) => (_$14.Lc === code))));
});
function $isArrayOf_Lpresto_types$SingleAppToken(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kg)));
}
export { $isArrayOf_Lpresto_types$SingleAppToken as $isArrayOf_Lpresto_types$SingleAppToken };
var $d_Lpresto_types$SingleAppToken = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SingleAppToken, "presto.types$SingleAppToken", ({
  kg: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$SingleAppToken as $d_Lpresto_types$SingleAppToken };
//# sourceMappingURL=presto.types$-Single-App-Token.js.map
